<template>
  <div class="layout">
    <Header />
    <div class="main">
      <router-view></router-view>
      <el-backtop></el-backtop>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/footer.vue'
import Header from './components/header.vue'
export default {
  name: 'Layout',
  components: { Header, Footer },
  props: [],
  data() {
    return {}
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  background-color: #edf2f6;
  .main {
    min-height: calc(100% - 113px);
  }
}
</style>